import { useTranslation } from 'react-i18next';
import { Callout } from '@components/callout';
import { Divider } from '@components/divider';
import { IconInfo } from '@components/icons';
import classNames from 'classnames';
export interface TotalPriceSummaryProps {
  offlinePrice?: string | number;
  onlinePrice?: string | number;
  ddpPrice?: string | number;
  isVisible: boolean;
}
export const TotalPriceSummary = ({ offlinePrice, onlinePrice, ddpPrice, isVisible }: TotalPriceSummaryProps) => {
  const { t } = useTranslation();
  if (!isVisible) return null;
  return (
    <div className={classNames('grid grid-cols-2 justify-between gap-2')}>
      <Divider className='col-span-full py-0 mt-1 mb-1' />
      {!!ddpPrice && (
        <>
          <p className='text-secondary text-body-s text-left'>{t('offers:admissionDDPLabel')}</p>
          <p className='text-secondary text-body-s text-right'>{ddpPrice}</p>
        </>
      )}
      <p className='text-primary text-subtitle-m text-left'>
        {offlinePrice ? t('offers:offerDownpayment') : t('offers:totalSale')}
      </p>
      <p className='text-primary text-subtitle-m text-right'>{onlinePrice}</p>
      {!!offlinePrice && (
        <Callout
          icon={IconInfo}
          className='col-span-full border-0'
          title={`${t('offers:payOnPremise')} ${offlinePrice}`}
          color='amber'></Callout>
      )}
    </div>
  );
};
